<div class="scrollable">
    <panel [noButton]="true">
        <h5>Editar o Crear Entidad</h5>
        <div class="row" [formGroup]="entityForm">
            <div class="col-md-6 col-xl-4 my-2">
                Código:
                <input type="text" class="form-control" formControlName="code">
            </div>
            <div class="col-md-6 col-xl-4 my-2">
                Nombre:
                <input type="text" class="form-control" formControlName="name">
            </div>
            <div class="col-md-6 col-xl-4 my-2">
                Grupo:
                <ng-select [items]="groups" formControlName="groupId" bindLabel="name" bindValue="id"
                    placeholder="Seleccione un grupo"></ng-select>
            </div>
            <div class="col-md-6 col-xl-4 my-2">
                Campo:
                <ng-select [items]="offices" formControlName="officeId" bindLabel="acronym" bindValue="id"
                    placeholder="Seleccione un campo"></ng-select>
            </div>
            <div class="col-md-6 col-xl-4 my-2">
                Auditor:
                <ng-select [items]="auditors" formControlName="auditorId" bindLabel="displayName" bindValue="id"
                    placeholder="Seleccione un auditor"></ng-select>
            </div>
        </div>
        <div class="modal-footer mt-5">
            <button class="btn btn-danger btn-xs mx-1" (click)="cancel()">Cancelar</button>
            <button class="btn btn-primary btn-xs mx-1" (click)="save()">Guardar</button>
        </div>


    </panel>
</div>